import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { APIService } from '@/services/APIService';

export class api_experiment extends APIService {
  constructor(api_base_url, is_dummy = false) {
    super(api_base_url);
    this.is_dummy = is_dummy;
  }
  
  setExperimentOverrideOn(school_id, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/setBookingOverrideOn.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(response => response.data);
    }
  }
  setExperimentOverrideOff(school_id, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/setBookingOverrideOff.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(response => response.data);
    }
  }
  getSetupPhoto(school_id, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getSetupPhoto.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getLabManual(school_id, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getLabManual.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getExperimentVideoDemo(school_id, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getExperimentVideoDemo.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  checkBookingEnd(booking_id, school_id, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/checkBookingEnd.php?`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          booking_id: booking_id,
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  checkOverride(booking_id, school_id, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/checkOverride.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          booking_id: booking_id, 
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  setChart(school_id, experiment, equipment_id, device_id, chart) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/setChart.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('chart', chart);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(response => response.data);
    }
  }
  getChart(session_token, role, school_id, experiment, equipment_id, device_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getChart.php`;
    var dummy_response = {
      value: [
        {
          x: 10,
          y: 500
        },
        {
          x: 15,
          y: 114
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          session_token: session_token,
          role: role,
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
        }
      }).then(response => response.data);
    }
  }
  getChartMultiple(session_token, role, school_id, experiment, equipment_id, device_id, no_of_data, data1, data2) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getChartMultiple.php`;
    var dummy_response = {
      value: []
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          session_token: session_token,
          role: role,
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
          no_of_data: no_of_data,
          data1: data1,
          data2: data2
        }
      }).then(response => response.data);
    }
  }
  clearChartMultiple(school_id, experiment, equipment_id, device_id, no_of_data, data) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/clearChartMultiple.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('no_of_data', no_of_data);
    bodyFormData.set('data', data);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(response => response.data);
    }
  }
  setValue(experiment, equipment_id, device_id, value) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/setValue.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('value', value);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(function (response) {
          //handle success
          console.log(response);
        });
    }
  }
  getCommand(experiment, equipment_id, device_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getCommand.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {

      return axios.get(url, {
        params: {
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
        }
      }).then(response => response.data);
    }
  }
  getValue(session_token, role, school_id, experiment, equipment_id, device_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getValue.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {

      return axios.get(url, {
        params: {
          session_token: session_token,
          role: role,
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
        }
      }).then(response => response.data);
    }
  }
  boardGetValue(experiment, equipment_id, device_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/experiment/boardGetValue.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {

      return axios.get(url, {
        params: {
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
        }
      }).then(response => response.data);
    }
  }
  setCommand(session_token, role, school_id, experiment, equipment_id, device_id, command) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/setCommand.php`;
    //const url = `${this.api_base_url}/api/iot/bluerhinos/phpmqtt/src/publish.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('session_token', session_token);
    bodyFormData.set('role', role);
    bodyFormData.set('school_id', school_id);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('command', command);
    
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(response => response.data);
    }
  }
  setPhoto(experiment, equipment_id, filename_prefix, cb) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/experiment/setPhoto.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('filename_prefix', filename_prefix);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(function (response) {
          if (cb) {
            cb();
          }
        });
    }
  }
  zipPhotos(session_token, role, experiment, equipment_id, device_id, cb) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/experiment/zipPhotos.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('session_token', session_token);
    bodyFormData.set('role', role);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(function (response) {
          if (cb) {
            cb();
          }
        });
    }
  }
  getPhotoTime(equipment_id, cb) {
    var self = this;
    const url = `${this.api_base_url}/api/experiment/getPhotoTime.php`;
    return axios.get(url, {
      params: {
        equipment_id: equipment_id,
      }
    }).then(function (response) {
      if (cb) {
        cb(response.data);
      }
    });
  }
  rebootCamera(url) {
    var self = this;
    return axios.get(url, {
    }).then(function (response) {
    });
  }
  boardGetChart(experiment, equipment_id, device_id, data) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/experiment/boardGetChart.php`;
    var dummy_response = {
      value: [
        {
          x: 10,
          y: 500
        },
        {
          x: 15,
          y: 114
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
          data: data
        }
      }).then(response => response.data);
    }
  }
  boardGetChartFileLine(experiment, equipment_id, device_id, data) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/experiment/boardGetChartFileLine.php`;
    var dummy_response = {
      value: [
        {
          x: 10,
          y: 500
        },
        {
          x: 15,
          y: 114
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
          data: data
        }
      }).then(response => response.data);
    }
  }
  boardSetChart(experiment, equipment_id, device_id, data_1, data_2) {
    var self = this;
    const url = `${this.api_base_url}/api/experiment/boardSetChart.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('data_1', data_1);
    bodyFormData.set('data_2', data_2);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(function (response) {
          //handle success
          console.log(response);
        });
    }
  }
  readDataFromFile(experiment, equipment_id, device_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/experiment/readDataFromFile.php`;
    var dummy_response = {
      value: [
        {
          x: 10,
          y: 500
        },
        {
          x: 15,
          y: 114
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id
        }
      }).then(response => response.data);
    }
  }
  setDataToFile(experiment, equipment_id, device_id, records) {
    var self = this;
    const url = `${this.api_base_url}/api/experiment/setDataToFile.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('records', records);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(response => response.data);
    }
  }
  getBoardFilename(experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/experiment/getBoardFilename.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          experiment: experiment,
          equipment_id: equipment_id,
        }
      }).then(response => response.data);
    }
  }
  getBoardPhotoName(experiment, equipment_id, light) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/experiment/getBoardPhotoName.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          experiment: experiment,
          equipment_id: equipment_id,
          light: light
        }
      }).then(response => response.data);
    }
  }
  getIGraphName(experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/experiment/getIGraphName.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  downloadZipExperimentData(school_id, experiment, equipment_id, device_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/downloadZipExperimentData.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id
        }
      }).then(response => response.data);
    }
  }
}
